import { type User, type Customer } from "@/shared/generated/graphql";

export interface CustomerBase {
  id: string;
  name: string;
  name2?: string;
  number?: string;
  user: {
    id: string;
  };
}

export const mapToCustomerBaseType = (
  data: Customer,
  user: User,
): CustomerBase => {
  return {
    id: data.id,
    name: data.name,
    name2: data.name2 || undefined,
    number: data.customerNumber || undefined,
    user: {
      id: user.userId,
    },
  };
};
